import { mount } from "@vue/test-utils";
import ReferidosEmprendedores from "@/views/ReferidosEmprendedores";

jest.mock("@/views/ReferidosEmprendedores", () => ({
  ...jest.requireActual("@/views/ReferidosEmprendedores"),
  __esModule: true,
  default: {
    email: "mockedValue@.com"
  }
}));

describe("ReferidosEmprendedores test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(ReferidosEmprendedores);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component ReferidosEmprendedores", () => {
    expect(wrapper).toBeDefined();
  });
});
